import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  flex-direction: column;
`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const LoadingText = styled.div`
  color: white;
  font-size: 18px;
  margin-top: 20px;
`;

export const ProgressText = styled.div`
  color: #3498db;
  font-size: 16px;
  margin-top: 10px;
`;

export const StatusText = styled.div`
  color: #666;
  font-size: 14px;
  margin-top: 5px;
  text-align: center;
`;
